import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import styles from './ForgetEmail.module.css';
import {
  ForgetEmailElement,
  ForgetEmailElementInterface,
} from '../ForgetEmailElement';
import { MobileView } from '../mobile/ForgetEmail.mobile';

export const DesktopView = (): JSX.Element => {
  const forgetEmailElement: ForgetEmailElementInterface = ForgetEmailElement();
  return (
    <React.Fragment>
      <Box className={styles.desktopMainPage}>
        <Box className={styles.desktopLeftImageFrameBox}>
          <Box className={styles.desktopLeftImage}>
            <img
              style={{ width: 'inherit' }}
              id="login-image"
              alt=""
              src="assets/login/login-image@1x.png"
            />
          </Box>
          <Box className={styles.desktopRightMainGroup}>
            <Box>
              <MobileView />
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
